import React from 'react';
import Image from 'next/image';
import { services } from '@/constants/constants';

// import { GallerySlider } from "@/src/HOC/SwiperSlider";
// import { SwiperSlide } from "swiper/react";
// import LeadFormReview from "./LeadFormReview";
const ServiceContainer = () => {
  return (
    <div className="relative basis-2/5 w-full max-w-[40%] h-full z-10 border-r border-gray-500 hidden lg:block">
      {/* <Image
        src={ModalBgImage}
        alt="Banner"
        className="h-full w-full object-cover object-center absolute inset-0 -z-50"
      /> */}
      {/* <div className="absolute inset-0 bg-black opacity-15 -z-50"></div> */}
      <div className="py-4 px-10 ">
        <h4 className="font-poppins text-lg font-bold text-black tracking-tight leading-tight ">
          How <span className="text-primary">CollegeHai </span> supports your journey?
        </h4>
        <div className="w-full mt-2">
          {/* <GallerySlider className="custom-pagination"> */}
          {/* <SwiperSlide> */}
          <div className="grid grid-cols-2 gap-x-4 gap-y-3 mt-3 px-2 py-1">
            {services?.map((service: any, index: any) => (
              <div
                key={index}
                className="bg-white shadow p-2 rounded-lg flex flex-col gap-y-1 items-center justify-center border"
              >
                <Image
                  src={service?.icon}
                  alt={service.name ?? 'service'}
                  width={500}
                  height={500}
                  className="w-[4rem] h-[4rem] object-contain"
                />
                <p className="font-inter text-primary-text text-xs font-semibold">{service.name}</p>
              </div>
            ))}
          </div>
          {/* </SwiperSlide> */}
          {/* <SwiperSlide>
              <div className="p-4 bg-gray-100 shadow rounded-lg">
                <h3 className="text-xl font-semibold">College Card</h3>
                Your college card content here
              </div>
            </SwiperSlide> */}
          {/*   <SwiperSlide>
              <div className="p-4 bg-gray-100 shadow rounded-lg">
                <h3 className="text-xl font-semibold">College Card</h3>
                {/* Your college card content here */}
          {/* </div>
            </SwiperSlide> */}
          {/* </GallerySlider> */}
        </div>
      </div>
      {/* <LeadFormReview /> */}
    </div>
  );
};

export default ServiceContainer;
